import { memo, useCallback } from "react";

import type { Watchlist } from "./WatchlistItemView";
import WatchlistItemView from "./WatchlistItemView";

/**
 * Props for WatchlistItemContainer component
 */
interface WatchlistItemContainerProps {
  readonly watchlist: Watchlist;
  readonly isSelected: boolean;
  readonly onSelect: (watchlistId: string) => void;
  readonly onClose: () => void;
}

/**
 * WatchlistItemContainer - Container Component
 * Manages logic and callbacks for a single watchlist item.
 * Memoized to prevent unnecessary re-renders of the dropdown item list.
 * @param root0 - The component props
 * @param root0.watchlist - The watchlist data
 * @param root0.isSelected - Whether this watchlist is currently selected
 * @param root0.onSelect - Callback when a watchlist is selected
 * @param root0.onClose - Callback to close the dropdown
 */
const WatchlistItemContainer = memo(
  ({
    watchlist,
    isSelected,
    onSelect,
    onClose,
  }: WatchlistItemContainerProps) => {
    const handlePress = useCallback(() => {
      onSelect(watchlist.id);
      onClose();
    }, [watchlist.id, onSelect, onClose]);

    return (
      <WatchlistItemView
        watchlist={watchlist}
        isSelected={isSelected}
        onPress={handlePress}
      />
    );
  }
);

WatchlistItemContainer.displayName = "WatchlistItemContainer";

export default WatchlistItemContainer;
